module.exports = __webpack_public_path__ + "static/kran03_1024-662085cb04cd1fd8315321e169484369.jpg";